import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { APPS, BUNDLE, ownsNone } from "@/lib/apps";
import { Reveal } from "@/components/temple/Reveal";

// "Both apps together" offer, shown only to people who own neither app.
export default function BundleBand() {
  const { user } = useAuth();
  if (user && !ownsNone(user)) return null;
  return (
    <Reveal className="mt-6">
      <Link to="/initiate?product=bundle" data-testid="apps-bundle" className="group relative block overflow-hidden border border-[#D9B47A]/40 bg-[#120A0B] p-7 sm:p-10 hover:border-[#D9B47A] transition-colors duration-500">
        <span aria-hidden className="pointer-events-none absolute -right-24 -top-24 w-80 h-80 rounded-full bg-[#C2414F]/15 blur-3xl" />
        <div className="relative grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-3 flex -space-x-5">
            {[APPS.gates, APPS.quantum].map((a, k) => (
              <img key={a.key} src={a.icon.replace("192", "512")} alt="" className={`w-20 h-20 sm:w-24 sm:h-24 rounded-[22%] border-2 border-[#120A0B] shadow-[0_20px_50px_rgba(0,0,0,0.6)] transition-transform duration-700 ${k ? "group-hover:translate-x-2 group-hover:rotate-6" : "group-hover:-rotate-6"}`} />
            ))}
          </div>
          <div className="md:col-span-6">
            <p className="font-tt-mono text-[12px] uppercase tracking-[0.25em] text-[#E8838E]">The complete path · save {BUNDLE.save}</p>
            <p className="mt-3 font-display text-3xl sm:text-4xl leading-tight">Both apps, <em className="text-[#D9B47A]">for life.</em></p>
            <p className="mt-3 text-[15px] text-[#CFC2B6]">13 Gates to Ecstasy and Quantum Intimacy together, unlocked with one payment.</p>
          </div>
          <div className="md:col-span-3 md:text-right">
            <p data-testid="apps-bundle-price" className="font-display text-5xl">{BUNDLE.price} <span className="text-lg text-[#D9B47A]">AUD</span></p>
            <p className="mt-1 text-sm text-[#A8998C]"><s>$594</s> when bought separately</p>
            <span className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#D9B47A] text-[#0A0706] px-6 py-3.5 font-tt-mono text-[12px] uppercase tracking-[0.2em] group-hover:bg-[#F2E8DF] transition-colors">Unlock both <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" /></span>
          </div>
        </div>
      </Link>
    </Reveal>
  );
}
